/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable no-alert */
import { Button, Modal } from 'react-bootstrap';
import XpektorButton from '../../../Components/XpektorButton/XpektorButton';
import './XpektorBootstrapModal.scss';

export default function ConfirmActionModal({
  handleClose,
  description,
  actionButtonText,
  danger,
  onConfirm,
}) {
  return (
    <Modal
      show
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      className="border-0 xpektor-bootstrap-modal"
      centered
    >
      <Modal.Header className="xpektor-bootstrap-modal">
        <Modal.Title>Är du säker?</Modal.Title>
        <Button className="btn-close" bsPrefix="button" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="border-0">
        <p className="confirm-description">
          {description}
          <br />
          <br />
          Vill du fortsätta?
        </p>
        <div className="confirm-row">
          <XpektorButton
            content={actionButtonText}
            onClick={() => {
              onConfirm();
              handleClose();
            }}
            variant={danger ? 'red' : ''}
          />
          <XpektorButton
            content="Avbryt"
            variant="outline"
            onClick={handleClose}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}
